module.exports = __webpack_public_path__ + "img/aeroland-app-showcase-image-03.24ae99cb.jpg";